import {WixSdk} from '@wix/js-sdk-wrapper';

export const getMetaSiteId = () => {
  return WixSdk.Utils.getInstanceValue('metaSiteId');
};
